import { Search } from "lucide-react"

import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

// Shared search box harvested from the four topbar/list search inputs (AppShell,
// Projects, Messages, FindFreelancers). Built on the DS Input so provenance holds
// (components/tuw/ is linted): the control is a real <Input>, stripped of its own
// border/height/padding/ring so it renders as the borderless field inside the
// bordered <label> wrapper, matching the pre-Hallmark look.
//
// value?: string, onChange?: (value: string) => void — omit both for an uncontrolled field.
// placeholder: string
// className?: string       — wrapper layout/visual overrides per callsite (max-w, margins, bg, border).
// inputClassName?: string  — rare; overrides on the inner Input (e.g. a per-site text size).
function SearchField({ value, onChange, placeholder, className, inputClassName, ...rest }) {
  return (
    <label
      className={cn(
        "flex items-center gap-[9px] rounded-[10px] border border-border bg-card px-[13px] py-[9px] text-ink-3",
        className
      )}
    >
      <Search className="size-4 shrink-0" strokeWidth={2} />
      <Input
        value={value}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        placeholder={placeholder}
        className={cn(
          "h-auto w-full border-none bg-transparent p-0 text-[13.5px] text-foreground shadow-none outline-none focus-visible:ring-0 placeholder:text-ink-3 dark:bg-transparent md:text-[13.5px]",
          inputClassName
        )}
        {...rest}
      />
    </label>
  )
}

export default SearchField
